export const CUENTA_CONTABLE_GRUPO_ENUM = {
  FINANCIACION_BASICA: 1,
  ACTIVO_NO_CORRIENTE: 2,
  EXISTENCIAS: 3,
  ACREEDORES_Y_DEUDORES: 4,
  CUENTAS_FINANCIERAS: 5,
  COMPRAS_Y_GASTOS: 6,
  VENTAS_E_INGRESOS: 7,
  GASTOS_DEL_PATRIMONIO_NETO: 8,
  INGRESOS_DEL_PATRIMONIO_NETO: 9,
} as const

export type CuentaContableGrupoEnumType =
  (typeof CUENTA_CONTABLE_GRUPO_ENUM)[keyof typeof CUENTA_CONTABLE_GRUPO_ENUM]
